import { StatusTracking } from "@/config";
import { getService } from "./apiService"

export type TOrder = {
    _id: string;
    businessId: string;
    tableId: string;
    orderId: string;
    detailId?: string;
    tableName: string;
    status: string;
    name: string;
    nameKH: string;
    quantity: number;
    price: number;
    instruction: string;
    options: Option[];
    statusTracking: StatusTracking;
    requiresCooking: boolean;
    createdByUser: {
        _id: string;
        name: string;
    },
    tracking?: {
        pending: string;
        reject: string;
        accept: string;
        process: string;
        completed: string;
    },
    discount?: number;
    discountPercent?: number;
    code?: string;
}

type Option = {
    name: string;
    nameKH: string;
    values?: Option[];
    _id: string;
    price?: number;
}

const url = "/waiters/ready-orders";

async function getOrder(params: any) {
    return await getService<TOrder[]>({
        url, params: {
            status: params.status ? params.status : 'Complete',
            sort: -1,
        }
    })
}

export { getOrder }